<template>
  <progress
    v-if="isRouteProgressVisible"
    class="route-progress-bar"
    aria-label="Seite wird geladen"
  ></progress>
</template>

<script setup lang="ts">
/**
 * Schlanker, globaler Fortschrittsindikator für Routenwechsel.
 *
 * Die Sichtbarkeit wird zentral über `useRouteProgress` (start/stopRouteProgress in router.ts)
 * gesteuert. Anzeige erfolgt erst nach einer konfigurierbaren Verzögerung
 * (FEATURE_FLAGS.ROUTE_PROGRESS_INDICATOR.DELAY_MS, Default 200ms), um Flackern bei
 * schnellen Routenwechseln zu vermeiden. Insgesamt per FEATURE_FLAGS.ROUTE_PROGRESS_INDICATOR.ENABLED
 * (Default: false) schaltbar.
 *
 * Nutzt das native <progress>-Element (ohne value/max = indeterminate) statt
 * role="progressbar", siehe Sonar S6819 (Tag statt ARIA-Rolle bevorzugen).
 */
import { isRouteProgressVisible } from '@/composables/useRouteProgress'
</script>

<style lang="scss" scoped>
.route-progress-bar {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 3px;
  border: none;
  appearance: none;
  overflow: hidden;
  background-color: transparent;
  pointer-events: none;

  // Indeterminate Darstellung (kein value-Attribut) für WebKit/Blink
  &::-webkit-progress-bar {
    background-color: transparent;
  }

  &::-webkit-progress-value {
    background-color: var(--zurich-blue, #2167ae);
  }

  // Firefox
  &:indeterminate {
    background-color: transparent;
  }

  &::-moz-progress-bar {
    background-color: var(--zurich-blue, #2167ae);
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 40%;
    height: 100%;
    background-color: var(--zurich-blue, #2167ae);
    animation: route-progress-bar-slide 1s ease-in-out infinite;
  }
}

@keyframes route-progress-bar-slide {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(250%);
  }
}
</style>
